import { URL_PREFIX } from '../constants/api';
import type { DataFreshnessResponse } from '../types/data-freshness';

export const getDataFreshness = async (): Promise<DataFreshnessResponse> => {
  try {
    const url = `${URL_PREFIX}/api/v1/utility/pipelines`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Failed to fetch data freshness: ${response.statusText}`);
    }

    const data = (await response.json()) as DataFreshnessResponse;

    return data;
  } catch (error) {
    console.warn('Failed to get data freshness:', error);

    throw error;
  }
};
